import { ReactElement } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ThemeProvider } from 'styled-components';

import Routes from './Routes/Routes';

import GlobalStyles from '../../styles/GlobalStyles';
import Theme from '../../styles/Theme/Theme';
import { A2HSProvider } from '../../contexts/A2HSContext';
import { AuthProvider } from '../../contexts/AuthContext';
import { GlobalStateProvider } from '../../contexts/GlobalStateContext';
import { ResponsiveProvider } from '../../contexts/ResponsiveContext';
import { TranslationProvider } from '../../contexts/TranslationContext';

// AWS Amplify Configuration
import awsconfig from '../../aws-exports';
import { Amplify } from 'aws-amplify';
Amplify.configure(awsconfig);

// React Query setup
const queryClient = new QueryClient();

function App(): ReactElement {
    return (
        <QueryClientProvider client={queryClient}>
            <AuthProvider>
                <A2HSProvider>
                    <ResponsiveProvider>
                        <TranslationProvider>
                            <GlobalStateProvider>
                                <ThemeProvider theme={Theme}>
                                    <GlobalStyles />
                                    <Routes />
                                    <ReactQueryDevtools position='bottom-right' />
                                </ThemeProvider>
                            </GlobalStateProvider>
                        </TranslationProvider>
                    </ResponsiveProvider>
                </A2HSProvider>
            </AuthProvider>
        </QueryClientProvider>
    );
}

export default App;
